import styled from "styled-components"

export const Filter = styled.div`
  & .filter-label {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 120%;
    color: #b2c3d7;
  }
  & .filter-input {
    &::placeholder {
      color: #595f62;
    }
    font-family: "Roboto";
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 120%;
    color: #595f62;
  }
`
